export default __webpack_public_path__ + "static/media/recruiter_employee_red.44909c12.svg";